var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 19.5546L3 19.5546V11.7479H6V19.5546ZM2.99999 21.5546L5.99999 21.5546C7.10456 21.5546 8 20.6592 8 19.5546V11.7479C8 10.6433 7.10457 9.7479 6 9.7479H3C1.89543 9.7479 1 10.6433 1 11.7479V19.5546C1 20.6592 1.89542 21.5546 2.99999 21.5546Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 20.7499C6.25 21.1642 6.58579 21.4999 7 21.4999H18.081C19.2496 21.4999 20.2906 20.7614 20.6766 19.6584L22.7766 13.6584C23.4024 11.8704 22.0754 9.99994 20.181 9.99994H15.6541L15.7907 9.69257C16.757 7.51844 16.2845 4.97375 14.6021 3.29141L14.5303 3.21961C14.2374 2.92672 13.7626 2.92672 13.4697 3.21961L6.46967 10.2196C6.32902 10.3603 6.25 10.551 6.25 10.7499V20.7499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpSolidStandard);
export default __webpack_public_path__ + "static/media/thumbs-up-solid-standard.ce2fbbd52432070acf620a9ffe4a25fa.svg";
export { ForwardRef as ReactComponent };